import { getEnvironment, getDomain, getProtocol, isDev } from '@library/environment/isomorphic'

export const STATIC_ASSET_DIRECTORY = '/webclient-static-assets'

// FEF-1394 TODO - we should be able to configure root domain for static assets
function getAssetsBaseURL(assetDirectory: string) {
  // On a local dev machine these files are served from the koa-mounted
  // STATIC_ASSET_DIRECTORY, regardless of the deployed environment identity.
  if (isDev()) {
    return assetDirectory
  }

  const environment = getEnvironment()
  const domain = getDomain()
  const protocol = getProtocol()

  switch (environment) {
    case 'production':
    case 'staging':
      return `${protocol}//${environment}-assets.${domain}${assetDirectory}`

    default:
      // Squad environment
      return `${protocol}//s3-gousto-${environment}-assets.s3.amazonaws.com${assetDirectory}`
  }
}

/**
 * Returns URL for where assets in the static-assets (non-bundled) files are served,
 * regardless of environment
 *
 * @example
 * // File exists in src/modules/library/static-assets/assets/fonts
 * getStaticAssetUrl('/fonts/Axiforma-Bold.otf')
 */
export function getStaticAssetURL(assetPath?: `/${string}`) {
  return `${getAssetsBaseURL(STATIC_ASSET_DIRECTORY)}${assetPath ? assetPath : ''}`
}
